import { z } from 'zod';

export const Z_Identity = z.object({
  has_signed_up: z.boolean(),
  identity: z.number(),
  is_logged_in: z.boolean(),
});

export type Identity = z.infer<typeof Z_Identity>;
